import { render, staticRenderFns } from "./ManagementSection.vue?vue&type=template&id=6a8cba5e&scoped=true&"
import script from "./ManagementSection.vue?vue&type=script&lang=js&"
export * from "./ManagementSection.vue?vue&type=script&lang=js&"
import style0 from "./ManagementSection.vue?vue&type=style&index=0&id=6a8cba5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8cba5e",
  null
  
)

export default component.exports